export enum MainFrontendConfigFieldAccess
{
    hidden = 0,
    readOnly = 1,
    editable = 2
}